const PRIVILEGED_ALL_OFFICE_ROLES = new Set(['ROLE_MANAGEMENT', 'ROLE_OWNER']);

export const normalizeRoles = (roles) => {
    const values = Array.isArray(roles) ? roles : [roles];
    return Array.from(new Set(values.filter(role => typeof role === 'string' && role.trim().length > 0)));
};

/**
 * Only display roles that the User Edit form can manage. Other stored roles,
 * such as ROLE_CAN_SWITCH_USER, are preserved by the API when the form saves.
 */
export const getEditableRoles = (roles, availableRoles = []) => {
    const availableKeys = new Set(availableRoles.map(role => role?.key).filter(Boolean));
    const editableRoles = normalizeRoles(roles).filter(role => availableKeys.has(role));
    return editableRoles.length > 0 ? editableRoles : ['ROLE_STAFF'];
};

export const requiresAllOfficeAccess = (roles) => normalizeRoles(roles)
    .some(role => PRIVILEGED_ALL_OFFICE_ROLES.has(role));
